import React from "react"

const ScrollToTop = ({ className }) => (
  <button
    className={"scroll--button pointer " + className}
    onClick={() => {window.scrollTo({ top: 0, left: 0, behavior: "smooth" })}}>
    <span className='link ul-link light small'>Back to top</span>
  </button>
)

export default ScrollToTop
